export default "__VITE_ASSET__32488a3b__"